// Add a delay of 2 seconds before setting up the DOMContentLoaded event listener

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
  //console.log('---->Im inside');
  //select button with data-open-modal and set the font-size to 0.8rem; for mobile and 1.0for web
  // Select all elements matching the divB class names
  const divBElements = document.querySelectorAll('div.addToCartContainer.Center>div>button');

  

  // Apply the CSS rules to each divB element
  divBElements.forEach((divB) => {
    divB.style.fontSize = '1rem';
  });


  // Define a media query for mobile view (max-width: 768px)
  const isMobileView = window.matchMedia("(max-width: 768px)");


  // Function to apply styles when in mobile view
  function applyMobileStyles() {
    if (isMobileView.matches) { // If screen width is 768px or less
      // Select all elements matching the divA class names
      // Select all elements matching the divA class names change swatch padding
      // padding: 0 5px; for mobile
      //const divAElements = document.querySelectorAll('div.swatchInnerContainer.DisplayUnderline.DisplayHeavyFont.BoxText');

      // Select all elements matching the divB class names
      const divCElements = document.querySelectorAll('div.addToCartContainer.Center>div>button');

     // Apply the CSS rules to each divA element
 /* divAElements.forEach((divA) => {
    divA.style.padding = '0 5px';
  });*/

      // Apply the CSS rules to each divB element
  divCElements.forEach((divC) => {
    divC.style.fontSize = '0.8rem';
  });

    }
  }

  
  // Apply the mobile styles on page load if in mobile view
  applyMobileStyles();

  // Add an event listener to apply styles when the window is resized
  isMobileView.addListener(applyMobileStyles);
    }, 1300); // 2000 milliseconds = 2 seconds
});
